import {
  List,
  Datagrid,
  TextField,
  TextInput,
  Filter,
  Button,
  useRecordContext,
} from "react-admin";
import { exporter, sectorsUsersExport, representativeExport } from "../utils";
import CustomActions from "../../../components/CustomActions";
import { ListPagination } from "../../../utils";

const SectorFilter = (props) => (
  <Filter {...props}>
    <TextInput label="ID" source="id" alwaysOn />
    <TextInput label="Laboratório" source="lab.name" alwaysOn />
  </Filter>
);

export const SectorsUsersExport = ({ label }) => {
  const record = useRecordContext();

  return record.type !== "GD" ? (
    <Button label={label} onClick={() => sectorsUsersExport(record)} />
  ) : (
    <div />
  );
};

export const RepresentativeExport = ({ label }) => {
  const record = useRecordContext();

  return record.type === "GD" ? (
    <Button label={label} onClick={() => representativeExport(record)} />
  ) : (
    <div />
  );
};

export const SectorList = (props) => (
  <List
    hasCreate={true}
    bulkActionButtons={<div />}
    perPage={25}
    title="Lista de Setores"
    actions={<CustomActions />}
    exporter={exporter}
    filters={<SectorFilter />}
    sort={{ field: "createdAt", order: "DESC" }}
    pagination={<ListPagination />}
    {...props}
  >
    <Datagrid rowClick="edit">
      <TextField label="Nome" source="name" />
      <TextField sortable={false} label="Laboratório" source="lab.name" />
      <TextField sortable={false} label="Representante" source="representative" />
      <TextField sortable={false} label="Tipo de Documento" source="type" />
      <SectorsUsersExport label="Exportar Médicos" />
      <RepresentativeExport label="Exportar Representantes" />
    </Datagrid>
  </List>
);

export default SectorList;